var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FlexLayout',{attrs:{"role":"region"}},[_c('BlockContainer',{attrs:{"id":"meal-plan-shop-selection","title":_vm.$t('mealPlanParameters.subTitle.shopSelection')}},[_c('Shops',{on:{"shop-selected":_vm.onShopSelected}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }